class AlertCountService {
  constructor() {
    this.count = 0
  }

  setCurrentCount(alerts) {
    this.count = alerts.length
  }

  get currentCount() {
    return this.count
  }

}

AlertCountService.$inject = []

export default AlertCountService
